import { service } from '@ember/service';
import Component from '@glimmer/component';
import roleValidation from 'scaleflow/validators/role';
import { validatePresence } from 'ember-changeset-validations/validators';
import { action } from '@ember/object';

export default class RolesCreateRoleIndexComponent extends Component {
  @service router;
  @service intl;
  @service store;

  roleValidation = {
    ...roleValidation,
    name: validatePresence({
      presence: true,
      message: this.intl.t('roles.name-cannot-be-blank'),
    }),
  };

  get model() {
    return this.args.model;
  }

  get body() {
    return document.body;
  }

  @action
  goToListPage() {
    // If onSave callback provided, use it; otherwise fallback to router
    if (this.args.onSave) {
      this.args.onSave();
    } else {
      this.router.transitionTo('settings.roles.list');
    }
  }

  @action
  handleCreateRoleDismiss(changeset) {
    changeset.rollback();
    if (this.args.onCancel) {
      this.args.onCancel();
    } else {
      this.goToListPage();
      if (!this.args.isEdit) this.args.model.deleteRecord();
    }
  }

  @action
  async onSubmit(changeset, e) {
    e.preventDefault();
    try {
      changeset.validate();
      if (changeset.isInvalid) return;
      changeset.save().then(() => {
        this.goToListPage();
      });
    } catch (err) {
      console.log(err);
    }
  }

  @action
  validateProperty(changeset, property) {
    return changeset?.validate(property);
  }

  @action
  handlePeopleSelect(changeset, people) {
    changeset.set('people', people);
  }

  @action
  deleteRole() {
    this.model.destroyRecord().then(() => {
      // Update to use new route as fallback
      this.router.replaceWith('settings.roles.list');
    });
  }

  @action
  handleInput(changeset, e) {
    changeset.set(e.target.id, e.target.value);
  }
}
